/**
 * ===========================================================================
 * Beck Optikhandel – Verkaufseinheiten (VPE) / Mengeninkremente
 * Version 1.3
 * ===========================================================================
 *
 * Erzwingt Bestellmengen in Vielfachen der Verkaufseinheit.
 *
 * Wirkt auf:
 *   1. Produktseite   – Mengenfeld, Plus/Minus, In-den-Warenkorb
 *   2. Warenkorb-Sidebar und Warenkorbseite – Plus/Minus, Mengenfeld
 *   3. Bestehende Warenkoerbe – werden beim Laden einmalig korrigiert
 *
 * Aenderungen gegenueber 1.2:
 *   - Die Texte kommen jetzt aus snippets/beck-vpe.liquid und richten sich
 *     nach der Storefront-Sprache (Deutsch / Franzoesisch).
 *     Wortlaut also dort aendern, nicht hier.
 *   - Die Werte unten in STRINGS sind nur noch Notfall-Fallback, falls das
 *     Snippet keine Texte mitliefert.
 *
 * Bewusste Design-Entscheidungen:
 *   - window.fetch wird ueberschrieben, um Warenkorb-Anfragen zu korrigieren,
 *     bevor sie abgeschickt werden. Die Plus/Minus-Buttons in Sidebar und
 *     Warenkorb loesen kein change-Ereignis aus und die Sidebar wird nach
 *     jeder Aenderung neu gerendert – eine DOM-basierte Loesung waere dort
 *     unzuverlaessig. Jeder Schritt ist in try/catch gekapselt: Schlaegt das
 *     Umschreiben fehl, geht die Anfrage unveraendert durch.
 *   - Keine Abhaengigkeit von Theme-Klassennamen.
 *
 * Grenzen:
 *   - Reine Frontend-Pruefung. Ein direkter POST auf /cart/add von ausserhalb
 *     des Shops umgeht sie.
 *   - Themes, die den Warenkorb ueber XMLHttpRequest statt fetch aktualisieren,
 *     sind nicht abgedeckt. Moderne Shopify-Themes verwenden fetch.
 * ===========================================================================
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------------
   * Fallback-Texte. Der tatsaechliche Wortlaut steht in beck-vpe.liquid.
   * ------------------------------------------------------------------- */
  var STRINGS = {
    hint: 'Verkaufseinheit: {count} Stück. Bestellbar in Schritten von {count}.',
    adjusted: 'Menge auf {count} angepasst.'
  };

  var dataEl = document.getElementById('beck-vpe-data');
  if (!dataEl) return;

  var VPE = {};
  try {
    VPE = JSON.parse(dataEl.textContent) || {};
  } catch (err) {
    return;
  }
  if (!Object.keys(VPE).length) return;

  // Sprachabhaengige Texte aus dem Snippet uebernehmen.
  var stringsEl = document.getElementById('beck-vpe-strings');
  if (stringsEl) {
    try {
      var provided = JSON.parse(stringsEl.textContent) || {};
      Object.keys(provided).forEach(function (key) {
        if (typeof provided[key] === 'string' && provided[key]) STRINGS[key] = provided[key];
      });
    } catch (err) {
      /* Fallback-Texte bleiben aktiv */
    }
  }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartCache = { items: [] };

  function t(key, count) {
    return String(STRINGS[key] || '').split('{count}').join(count);
  }

  /* ---------------------------------------------------------------------
   * Rechenkern
   * ------------------------------------------------------------------- */
  function stepFor(variantId) {
    var value = parseInt(VPE[String(variantId)], 10);
    return value > 1 ? value : 1;
  }

  /**
   * direction  1 = aufrunden (Plus)
   * direction -1 = abrunden  (Minus)
   * direction  0 = kaufmaennisch runden (Eingabe)
   */
  function roundToStep(value, step, direction) {
    if (step <= 1) return Math.max(1, value);

    var units;
    if (direction > 0) units = Math.ceil(value / step);
    else if (direction < 0) units = Math.floor(value / step);
    else units = Math.round(value / step);

    if (units < 1) units = 1;
    return units * step;
  }

  function correctQuantity(variantId, requested, previous) {
    var step = stepFor(variantId);
    if (step <= 1) return requested;
    if (!requested || requested <= 0) return requested; // 0 = Position entfernen

    var direction = 0;
    if (typeof previous === 'number') {
      direction = requested > previous ? 1 : requested < previous ? -1 : 0;
    }

    var next = roundToStep(requested, step, direction);
    return next < step ? step : next;
  }

  /* ---------------------------------------------------------------------
   * Warenkorb-Zustand
   * ------------------------------------------------------------------- */
  function refreshCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        cartCache = cart || { items: [] };
        return cartCache;
      })
      .catch(function () {
        return cartCache;
      });
  }

  /** Findet Variante und bisherige Menge anhand von Varianten-ID oder Line-Key. */
  function lookupByKey(key) {
    if (key == null) return {};
    var raw = String(key);
    var variantId = raw.split(':')[0];
    var result = { variantId: variantId };

    (cartCache.items || []).forEach(function (item) {
      if (String(item.key) === raw || String(item.variant_id) === variantId) {
        result.variantId = String(item.variant_id);
        result.previous = item.quantity;
      }
    });
    return result;
  }

  /** Findet Variante und bisherige Menge anhand der Zeilennummer (1-basiert). */
  function lookupByLine(line) {
    var index = parseInt(line, 10) - 1;
    var item = (cartCache.items || [])[index];
    if (!item) return {};
    return { variantId: String(item.variant_id), previous: item.quantity };
  }

  /* ---------------------------------------------------------------------
   * Anfragen an die Cart-API umschreiben
   * ------------------------------------------------------------------- */
  function isCartMutation(url) {
    return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(String(url));
  }

  function transformObject(data) {
    var changed = false;

    // /cart/update.js  →  { updates: { "<id>": 29 } }
    if (data && data.updates && typeof data.updates === 'object') {
      Object.keys(data.updates).forEach(function (key) {
        var requested = parseInt(data.updates[key], 10);
        if (isNaN(requested)) return;
        var info = lookupByKey(key);
        var next = correctQuantity(info.variantId, requested, info.previous);
        if (next !== requested) {
          data.updates[key] = next;
          changed = true;
        }
      });
      return changed;
    }

    // /cart/add.js  →  { items: [ { id, quantity } ] }
    if (data && Array.isArray(data.items)) {
      data.items.forEach(function (item) {
        var requested = parseInt(item.quantity, 10);
        if (isNaN(requested)) return;
        var next = correctQuantity(String(item.id).split(':')[0], requested);
        if (next !== requested) {
          item.quantity = next;
          changed = true;
        }
      });
      return changed;
    }

    // /cart/change.js  →  { line|id, quantity }
    if (data && data.quantity != null) {
      var requested = parseInt(data.quantity, 10);
      if (isNaN(requested)) return false;

      var info = data.line != null ? lookupByLine(data.line) : lookupByKey(data.id);
      var next = correctQuantity(info.variantId, requested, info.previous);
      if (next !== requested) {
        data.quantity = next;
        changed = true;
      }
    }

    return changed;
  }

  /** Verarbeitet FormData und URLSearchParams. */
  function transformParams(params) {
    var changed = false;
    var entries = [];

    params.forEach(function (value, key) {
      entries.push([key, value]);
    });

    entries.forEach(function (pair) {
      var match = String(pair[0]).match(/^updates\[(.+)\]$/);
      if (!match) return;

      var requested = parseInt(pair[1], 10);
      if (isNaN(requested)) return;

      var info = lookupByKey(match[1]);
      var next = correctQuantity(info.variantId, requested, info.previous);
      if (next !== requested) {
        params.set(pair[0], String(next));
        changed = true;
      }
    });

    if (typeof params.get === 'function' && params.get('quantity') != null) {
      var requested2 = parseInt(params.get('quantity'), 10);
      if (!isNaN(requested2)) {
        var info2 = params.get('line') != null ? lookupByLine(params.get('line')) : lookupByKey(params.get('id'));
        var next2 = correctQuantity(info2.variantId, requested2, info2.previous);
        if (next2 !== requested2) {
          params.set('quantity', String(next2));
          changed = true;
        }
      }
    }

    return changed;
  }

  /** Gibt den korrigierten Body zurueck oder null, wenn nichts zu aendern war. */
  function transformTextBody(text) {
    if (typeof text !== 'string' || !text) return null;

    var trimmed = text.replace(/^\s+/, '');
    if (trimmed.charAt(0) === '{') {
      var data = JSON.parse(text);
      return transformObject(data) ? JSON.stringify(data) : null;
    }

    var params = new URLSearchParams(text);
    return transformParams(params) ? params.toString() : null;
  }

  function rewriteArgs(args) {
    var input = args[0];
    var init = args[1];

    if (init && init.body != null) {
      var body = init.body;

      if (typeof body === 'string') {
        var rewritten = transformTextBody(body);
        if (rewritten !== null) {
          var nextInit = {};
          for (var prop in init) {
            if (Object.prototype.hasOwnProperty.call(init, prop)) nextInit[prop] = init[prop];
          }
          nextInit.body = rewritten;
          args[1] = nextInit;
        }
        return Promise.resolve(args);
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        transformParams(body);
        return Promise.resolve(args);
      }

      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        transformParams(body);
        return Promise.resolve(args);
      }

      return Promise.resolve(args);
    }

    // Request-Objekt ohne separates init
    if (input && typeof input !== 'string' && typeof input.clone === 'function' && input.method && input.method.toUpperCase() !== 'GET') {
      return input
        .clone()
        .text()
        .then(function (text) {
          var rewritten = transformTextBody(text);
          if (rewritten !== null) args[0] = new Request(input, { body: rewritten });
          return args;
        });
    }

    return Promise.resolve(args);
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__beckVpe) return;

    var originalFetch = window.fetch;

    var patched = function () {
      var args = Array.prototype.slice.call(arguments);
      var input = args[0];
      var url = typeof input === 'string' ? input : (input && input.url) || '';

      if (!isCartMutation(url)) return originalFetch.apply(window, args);

      var prepared;
      try {
        prepared = rewriteArgs(args);
      } catch (err) {
        prepared = Promise.resolve(args);
      }

      return prepared
        .catch(function () {
          return args;
        })
        .then(function (finalArgs) {
          return originalFetch.apply(window, finalArgs).then(function (response) {
            window.setTimeout(refreshCart, 0);
            return response;
          });
        });
    };

    patched.__beckVpe = true;
    window.fetch = patched;
  }

  /* ---------------------------------------------------------------------
   * Bestehende Warenkoerbe einmalig bereinigen
   * ------------------------------------------------------------------- */
  function sweepCart() {
    var lines = cartCache.items || [];
    var fixes = [];

    lines.forEach(function (item, index) {
      var step = stepFor(item.variant_id);
      if (step > 1 && item.quantity % step !== 0) {
        fixes.push({ line: index + 1, quantity: roundToStep(item.quantity, step, 0) });
      }
    });

    if (!fixes.length) return;

    var chain = Promise.resolve();
    fixes.forEach(function (fix) {
      chain = chain.then(function () {
        return fetch(ROOT + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: fix.line, quantity: fix.quantity })
        });
      });
    });

    chain
      .then(function () {
        if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------------
   * Produktseite
   * ------------------------------------------------------------------- */
  function messageEl(form) {
    var existing = form.querySelector('[data-beck-vpe-message]');
    if (existing) return existing;

    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) return null;

    var anchor = qtyInput;
    while (anchor.parentNode && anchor.parentNode !== form && anchor !== document.body) {
      anchor = anchor.parentNode;
    }
    if (anchor.parentNode !== form) return null;

    var el = document.createElement('p');
    el.className = 'beck-vpe-message';
    el.setAttribute('data-beck-vpe-message', '');
    form.insertBefore(el, anchor.nextSibling);
    return el;
  }

  function initProductForm(form) {
    if (form.hasAttribute('data-beck-vpe-init')) return;

    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    if (!idInput || !qtyInput) return;

    form.setAttribute('data-beck-vpe-init', '');

    var state = {
      last: parseInt(qtyInput.value, 10) || 1,
      fromButton: false,
      variant: idInput.value
    };
    var noticeTimer = null;

    function notice(text) {
      var el = messageEl(form);
      if (!el) return;
      el.classList.add('beck-vpe-message--adjusted');
      el.textContent = text;
      window.clearTimeout(noticeTimer);
      noticeTimer = window.setTimeout(function () {
        el.classList.remove('beck-vpe-message--adjusted');
        refresh(false);
      }, 4000);
    }

    function refresh(force) {
      var step = stepFor(idInput.value);
      var current = parseInt(qtyInput.value, 10) || 0;

      if (step > 1) {
        qtyInput.min = step;
        qtyInput.step = step;
        if (force || current < step || current % step !== 0) {
          qtyInput.value = roundToStep(current || step, step, 0);
        }
      } else {
        qtyInput.min = 1;
        qtyInput.step = 1;
      }

      state.last = parseInt(qtyInput.value, 10) || 1;

      var el = messageEl(form);
      if (el) {
        el.classList.remove('beck-vpe-message--adjusted');
        el.textContent = step > 1 ? t('hint', step) : '';
        el.hidden = step <= 1;
      }
    }

    function normalize() {
      var step = stepFor(idInput.value);
      if (step <= 1) {
        state.fromButton = false;
        return;
      }

      var value = parseInt(qtyInput.value, 10);
      if (!value || value < 1) value = step;

      var direction = 0;
      if (state.fromButton) {
        direction = value > state.last ? 1 : value < state.last ? -1 : 0;
      }
      state.fromButton = false;

      var next = roundToStep(value, step, direction);
      if (next < step) next = step;

      if (next !== value) {
        qtyInput.value = next;
        notice(t('adjusted', next));
      }
      state.last = next;
    }

    function watchVariant() {
      if (idInput.value !== state.variant) {
        state.variant = idInput.value;
        refresh(true);
      }
    }

    qtyInput.addEventListener('change', function () {
      window.setTimeout(normalize, 0);
    });
    qtyInput.addEventListener('blur', function () {
      window.setTimeout(normalize, 0);
    });

    form.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        if (target.closest('[name="add"], button[type="submit"]')) {
          state.fromButton = false;
          normalize();
          return;
        }

        if (target.closest('button, a[role="button"]')) {
          state.fromButton = true;
          window.setTimeout(normalize, 0);
        }
      },
      true
    );

    form.addEventListener(
      'submit',
      function () {
        state.fromButton = false;
        normalize();
      },
      true
    );

    form.addEventListener('change', function () {
      window.setTimeout(watchVariant, 0);
    });

    window.setInterval(watchVariant, 500);

    refresh(false);
  }

  function initProductForms() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms, initProductForm);
  }

  /* ---------------------------------------------------------------------
   * Start
   * ------------------------------------------------------------------- */
  patchFetch();

  function init() {
    initProductForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  refreshCart().then(sweepCart);

  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(init, 0);
  });
})();